export const getNamesToCheck = (items) => {
  if (!items) return [];
  const namesToCheck = items.reduce((names, item) => {
    if (item.name && item.isChecked === true) return [...names, item.name];
    return names;
  }, []);
  return namesToCheck;
};
